import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GenerateThumbnailSignedUrl.graphql';
import { Query, QuerygenerateThumbnailSignedUrlArgs } from '../../__generated__/globalTypes';

export const useGenerateThumbnailSignedUrlQuery = (
  options?: QueryHookOptions<Query, QuerygenerateThumbnailSignedUrlArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygenerateThumbnailSignedUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGenerateThumbnailSignedUrlLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygenerateThumbnailSignedUrlArgs>
): QueryResult<Query, QuerygenerateThumbnailSignedUrlArgs> & {
  getGenerateThumbnailSignedUrl: LazyQueryExecFunction<Query, QuerygenerateThumbnailSignedUrlArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGenerateThumbnailSignedUrl, result] = useLazyQuery<Query, QuerygenerateThumbnailSignedUrlArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGenerateThumbnailSignedUrl, ...result };
};

export const useGenerateThumbnailSignedUrlPromiseQuery = () => {
  const client = useApolloClient();

  const getGenerateThumbnailSignedUrl = useCallback(
    (options?: Omit<QueryOptions<QuerygenerateThumbnailSignedUrlArgs, Query>, 'query'>) =>
      client.query<Query, QuerygenerateThumbnailSignedUrlArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGenerateThumbnailSignedUrl };
};
// Suspense Query Hooks
export const useGenerateThumbnailSignedUrlSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygenerateThumbnailSignedUrlArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygenerateThumbnailSignedUrlArgs>(QUERY, {
    ...options
  });

  return result;
};
